export default class TabelaColunaUtils {
	sortable = false
	text = 'Texto'
	value = 'Valor'
	width = '5%'
	align = 'start'
	class = 'primary--text'

	constructor(texto, valor, width, align = 'start') {
		this.text = texto
		this.value = valor
		this.width = width
		this.align = align
	}
}
